export default {
	"lanEnTxt": '英文',
	"lanZhTxt": '中文',
	"login": '登录',
	"register": '注册',
	"loginPage": {
		"accountPlaceholder": "请输入手机号码/邮箱",
		"codePlaceholder": "请输入验证码",
		"passwordPlaceholder": "请输入密码",
		"getCode": "获取",
		"switchToPwd": "密码登录",
		"switchToCode": "验证码登录",
		"loginBtn": "登录",
		"noAccount": "没有账号,",
		"toRegister": "去注册",
		"agreePrefix": "已阅读并同意",
		"userAgreement": "《用户协议》",
		"confirm": "确定",
		"agreeFirst": "请先同意用户协议",
		"loginSuccess": "登录成功"
	},
	"registerPage": {
		"backLogin": "返回登录",
		"title": "注册账号",
		"modeLabel": "注册方式",
		"phoneMode": "手机号码",
		"emailMode": "邮箱",
		"mobilePlaceholder": "请输入手机号码",
		"emailPlaceholder": "请输入邮箱地址",
		"codePlaceholder": "请输入验证码",
		"getCode": "获取",
		"passwordPlaceholder": "登录密码",
		"confirmPwdPlaceholder": "确认密码",
		"registerBtn": "注册",
		"registerSuccess": "注册成功"
	},
	"confirmDialog": {
		"logoutTitle": "提示",
		"logoutMsg": "是否要退出登录？",
		"confirmBtn": "是",
		"cancelBtn": "否",
		"logoutErr": "退出登录异常："
	},
	"userTopBar": {
			"welcome": "HI 欢迎进入",
			"systemName": "助运猫系统",
			"memberId": "会员编号："
		},
		"header": {
			"nav": {
			"home": "首页",
			"logisticsQuery": "物流查询",
			"shopIndex": "代购商城",
			"freightEstimate": "运费估算",
			"mainBusiness": "主营业务",
			"latestNews": "最新资讯",
			"faq": "常见问题",
			"aboutUs": "关于我们"
		},
		"userName": "张德帅",
		"logout": "退出",
		"breadcrumb": {
			"label": "当前位置：",
			"home": "首页",
			"newsPage": "最新资讯",
			"backBtn": "返回"
		}
	},
	"footer": {
		"friendLinks": {
			"label": "友情链接",
			"baidu": "百度一下",
			"fengchi": "凤池天下",
			"douyin": "抖音"
		},
		"cols": {
			"resource": {
				"title": "资源",
				"latestNews": "最新消息",
				"faq": "常见问题"
			},
			"express": {
				"title": "快递",
				"prohibitedItems": "违禁物品禁存",
				"serviceTerms": "注册服务条款"
			},
			"solutions": {
				"title": "解决方案",
				"myOrder": "我的订单",
				"shippingTutorial": "海运教程",
				"orderManagement": "订单管理",
				"logisticsQuery": "物流查询",
				"shopIndex": "代购商城"
			},
			"about": {
				"title": "关于",
				"express100": "快递100",
				"aboutUs": "关于我们",
				"shentong": "申通快递",
				"yuantong": "圆通快递",
				"zhongtong": "中通快递"
			}
		},
		"contact": {
			"title": "关注或者联系我们",
			"desc": "添加助运猫公众号、小程序",
			"hotline": "咨询热线",
			"btnText": "联系我们",
			"btnText1": "国内电话",
			"btnText2": "国际电话",
			"btnText3": "微信"
		},
		"copyright": {
			"text": "Copyright©2016-2020. All rights reserved.易境通散货拼柜",
			"icp": "粤ICP备15111761号易境通海运技术支持"
		}
	},
	"userPageLeft":{
		"txt1": "首页",
		"txt2": "快件下单",
		"txt3": "我的订单",
		"txt4": "地址管理",
		"txt5": "唛头管理",
		"txt6": "仓库地址查询",
		"txt7": "个人资料",
		"txt8": "常见问题",
		"txt9": "联系客服",
		"txt10": "用户协议",
		"txt11": "退出登录",
	},
	"userPageL":{
		"txt1": "首页",
		"txt2": "快件下单",
		"txt3": "集运订单",
		"txt4": "我的包裹",
		"txt5": "代购订单",
		"txt6": "优惠券",
		"txt7": "我的收藏",
		"txt8": "地址管理",
		"txt9": "仓库地址查询",
		"txt10": "消息通知",
		"txt11": "个人资料",
		"txt12": "常见问题",
		"txt13": "用户协议",
		"txt14": "退出登录",
		"txt15": "仓库",
	},
	"indexHme":{
		"txt1": "选物流,就选助运猫",
		"txt2": "速度服务",
		"txt3": "双在线",
		"txt4": "使命必达",
		"txt5": "超靠谱",
		"txt6": "起运地",
		"txt7": "请选择",
		"txt8": "目的地",
		"txt9": "重量",
		"txt10": "长宽高",
		"txt11": "查询",
		"txt12": "业务流程",
		"txt13": "将货物寄到我们仓库 您坐等签收通知",
		"txt14": "我们的优势",
		"txt15": "速度，价格，安全，带给你全程贴心服务",
		"txt16": "安心交给我们",
		"txt17": "智能物流是利用集成智能化技术，使物流系统能模仿人的只能，具有思维感知推理判断和自行解决五六种某些问题的能力。",
		"txt18": "国际物流资讯",
		"txt19": "为你提供最新的行业资讯，动态消息",
		"txt20": "广州市甲壳虫数字",
		"txt21": "易境通是广州市甲壳虫数字科技有限公司旗下",
		"txt22": "腾讯云启创新生态是腾讯CSIG(云与智慧产业事业群)面向「中国企服创新公司」的孵化与合作窗口以资金租资源帮助初创企业快速发展。目前，业务主要包括加速优质企服公司成长的产业加速器服务大企业创新的产业共创营以及投资。",
		"txt23": "查看详情",
		"txt24": "请输入",
		"txt25": "长",
		"txt26": "宽",
		"txt27": "高",
		"txt28": "搜索国家/地区",
		"txt29": "无匹配结果",
		"process":[
			{"title":"查询价格","desc":"查询专线价格<br/>价格透明化"},
			{"title":"线上下单","desc":"一键下单<br/>仓库提前预报"},
			{"title":"仓库集合","desc":"将预报的包裹运输到<br/>指定的发货仓库"},
			{"title":"转运包裹","desc":"将货物转发<br/>运输到目的地"},
			{"title":"货物追踪","desc":"线上追踪订单<br/>线上追踪物流状态"},
			{"title":"货物到港","desc":"货物送到指定港口并<br/>生成货物运提单"},
			{"title":"尾程派送","desc":"完成最后100米<br/>将货物送到收货地址"},
			{"title":"完成签收","desc":"货物签收<br/>订单完成"}
		],
		"advantage":[
			{"title":"VIP级服务","desc":"专属客服 1V1 响应，7×24 小时在线答疑，快速解决运输中任何问题，享受贵宾级服务体验"},
			{"title":"快捷操作","desc":"数字化发货界面，一键查价、下单，物流轨迹同步至小程序，随时随地轻松管理订单，节省时间成本。"},
			{"title":"智能系统","desc":"引入智能 TMS 物流运输管理系统，实时监控运输节点，智能优化路线，提升运输效率与准确性"},
			{"title":"灵活计价","desc":"根据货物重量、体积、路线等提供多元计价方案自动匹配最优成本渠道，为您节省每一分预算。"},
			{"title":"渠道多元化","desc":"涵盖海运、空运、陆运等多种运输方式，针对不同需求与预算，提供个性化渠道选择，满足国际贸易场景。"},
			{"title":"经验丰富","desc":"十年以上国际物流服务团队，精通海运、空运全流程，成功服务数千家跨境企业，专业可靠值得信赖。"}
		],
	},
	"indexSeach":{
		"t1":"「物流查询」是帮您实时掌握货物动态的便捷工具!输入运单，即可随时查看货物位置、运输状态(如已揽收、在途、派送中)预计到达时间等信息，支持官网、APP、小程序等多平台查询。异常情况(如延误、破损)实时预警，助您轻松跟踪货物轨迹高效管理物流进度，让货物运输全程透明可控。",
		"t2": "请输入运单号",
		"t3": "查询",
		"t4": "暂无物流信息",
		"t5": "始发仓",
		"t6": "收货地址",
		"t7": "入仓号",
		"t8": "当前轨迹",
		"t9": "收缩",
		"t10": "展开",
		"t11": "请输入运单号或入仓号",
		"t12": "复制成功",
		"t13": "始",
		"t14": "终",
	},
	"indexFreight":{
		"t1":'「运费估算」是帮您快速预判物流成本的实用工具!输入货物重量、体积、运输目的地及方式(海运/空运陆运等) 系统自动匹配计费规则，实时生成包含运费估算的报价。支持多方案对比，助您提前规划预算、优化物流选择，发货前心中有数省时省力更省钱。',
		"t2":'',
		"t3":'起运地',
		"t4":'请选择',
		"t5":'目的地',
		"t6":'重量',
		"t7":'请输入',
		"t8":'长宽高',
		"t9":'长',
		"t10":'宽',
		"t11":'高',
		"t12":'查询',
		"t122":'暂无物流信息',
		"t13":'始发仓',
		"t14":'收货地址',
		"t15":'商品重量',
		"t16":'计算重量',
		"t17":'商品体积',
		"t18":'计算体积',
		"t19":'详情介绍',
		"t20":'下单',
		"t21":'描述',
		"t22":'出货渠道',
		"t23":'请选择起运地',
		"t24":'请选择目的地',
		"t25":'请输入重量',
		"t26":'请输入长',
		"t27":'请输入宽',
		"t28":'请输入高',
		"t29":'搜索国家/地区',
		"t30":'无匹配结果',
		"t31":'始',
		"t32":'终',
	},
	"indexFMsg":{
		"t1":"选物流, 就选助运猫",
		"t2":"速度服务",
		"t3":"双在线",
		"t4":"使命必达",
		"t5":"超靠谱",
		"t6":"送达时间",
		"t7":"目的地",
		"t8":"计费方式",
		"t9":"首重续重",
		"t10":"阶梯价格",
		"t11":"多级续重",
		"t12":"阶梯首重续重",
		"t13":"体积计算",
		"t14":"长",
		"t15":"宽",
		"t16":"高",
		"t17":"计费标准",
		"t18":"首重",
		"t19":"续重",
		"t20":"最大限重",
		"t21":"渠道规则限制",
		"t22":"暂无",
		"t23":"注意事项",
		"t24":"可寄物品",
		"t25":"报价标准",
		"t26":"；",
		"t27":"海运特殊渠道",
	},
	"newsList":{
		"t1":"暂无相关信息",
	},
	"newsMsg":{
		"t1":"文章详情",
		"t2":"发布日期",
		"t3":"上一篇",
		"t4":"下一篇",
	},
	"Business":{
		"t1":"助运猫 - 主营业务",
		"t2":"危险品标志  海运赔偿  敏感物等",
		"t3":"国际海运 — 海运整箱 拼箱进出口",
		"t4":"与全球28家船公司签定战略合作，提供全球整箱、拼箱进出口服务，主要航线，提供稳定的船期运价及舱位，享受充足的整拼箱订舱以及仓位，并保持客户服务的标准化和可靠性，同时慧承供应链还可以为客户提供报关等服务",
		"t5":"清关 — 美加、欧洲、东南亚、澳新DDP/DDU",
		"t6":"长期致力于世界各国服务，无论是个人还是公司，只需提供箱单发票，一口价一票收费，安排清关后直接按人指示预约送货，适用于DDU、DDP、LDP、EXW等各种国际贸易交易条款。",
		"t7":"国际空运 — 高效、快捷的一站式专业物流商",
		"t8":"已开通空运至北美、欧洲、日本、南美、非洲、澳洲等空运专线，同时可根据客户需要将货物单独安排航班空运，并代理目的地的清关、本地派送等事宜，将货物安全的送达",
		"t9":"立即咨询",
	},
	"other":{
		"t1":"常见问题",
		"t2":"公告",
	},
	"userCenter":{
		"t1":"运输信息",
		"t2":"全部订单",
		"t3":"仓库地址",
		"t4":"查看更多",
		"t5":"仓库名称",
		"t6":"邮政编码",
		"t7":"联系人",
		"t8":"联系电话",
		"t9":"收货地址",
		"t10":"快捷通道",
		"t11":"最新订单",
		"t12":"全部订单",
		"t13":"暂无订单信息",
		"t14":"序号",
		"t15":"入仓号",
		"t16":"下单时间",
		"t17":"出发地",
		"t18":"运输方式",
		"t19":"目的地",
		"t20":"状态",
		"t21":"操作",
		"t22":"待入库",
		"t23":"已入库",
		"t24":"已装箱",
		"t25":"运输中",
		"t26":"待签收",
		"t27":"已签收",
		"t28":"作废",
		"t29":"查看",
		"link1":"快件下单",
		"link2":"我的订单",
		"link3":"唛头管理",
		"link4":"物流查询",
		"link5":"运费估算",
		"link6":"仓库地址",
		"link7":"个人资料",
		"link8":"常见问题",
		"link9":"用户协议",
		"t30":"集运订单",
		"t31":"待处理",
		"t32":"待支付",
		"t33":"待发货",
		"t34":"已发货",
		"t35":"已签收",
		"t36":"已作废",
		"t37":"我的包裹",
		"t38":"全部包裹",
		"t39":"待入库",
		"t40":"已入库",
		"t41":"代购订单",
		"t42":"待付款",
		"t43":"待审核",
		"t44":"采购中",
		"t45":"售后",
		"t46":"快件下单",
		"t47":"优惠券",
		"t48":"我的收藏",
		"t49":"地址管理",
		"t50":"仓库地址",
		"t51":"物流查询",
		"t52":"运费估算",
		"t53":"消息通知",
		"t54":"个人资料",
		"t55":"常见问题",
		"t56":"用户协议",
		"t57":"订单号",
	},
	"uinfo": {
	  "t1": "个人资料",
	  "t2": "头像",
	  "t3": "昵称",
	  "t4": "请输入昵称",
	  "t5": "国家",
	  "t6": "请选择",
	  "t7": "手机号码",
	  "t8": "请输入手机号码",
	  "t9": "绑定",
	  "t10": "微信",
	  "t11": "请输入微信号",
	  "t12": "性别",
	  "sex1":'男',
	  "sex2":'女',
	  "t13": "城市",
	  "t14": "请输入城市",
	  "t15": "邮箱",
	  "t16": "请输入邮箱",
	  "t17": "请输入whatsapp",
	  "t18": "保存",
	  "t19": "绑定手机号",
	  "t20": "绑定邮箱",
	  "t21": "验证码",
	  "t22": "请输入验证码",
	  "t23": "获取验证码",
	  "t24": "返回",
	  "t25": "确定",
	  "t26": "搜索国家/地区",
	  "t27": "无匹配结果",
	},
	"point": {
		"t1": "仓库地址查询",
		"t2": "请输入联系人",
		"t3": "请输入电话号码",
		"t4": "请输入详细地址",
		"t5": "查询",
		"t6": "邮编",
		"t7": "复制地址",
	},
	"marks": {
		"t1": "唛头管理",
		"t2": "暂无相关信息",
		"t3": "默认",
		"t4": "编辑",
		"t5": "删除",
		"t6": "添加唛头",
		"t7": "修改唛头",
		"t8": "唛头名称",
		"t9": "请输入唛头名称",
		"t10": "联系电话",
		"t11": "请输入联系电话",
		"t12": "是否默认",
		"t13": "是",
		"t14": "否",
		"t15": "返回",
		"t16": "确认修改",
		"t17": "确认添加",
	},
	"olist": {
		"t1": "请输入订单号/入仓号/唛头",
		"t2": "搜索",
		"t3": "下单时间",
		"t4": "请选择",
		"t5": "全部月份",
		"t6n": "序号",
		"t6": "图片",
		"t7": "入仓号",
		"t8": "唛头",
		"t9": "重量(kg)",
		"t10": "体积(㎡)",
		"t11": "运输方式",
		"t12": "出发地",
		"t13": "目的地",
		"t14": "下单时间",
		"t15": "状态",
		"t16": "操作",
		"t17": "待入库",
		"t18": "已入库",
		"t19": "已装箱",
		"t20": "运输中",
		"t21": "待签收",
		"t22": "已签收",
		"t23": "作废",
		"t24": "编辑",
		"t25": "取消",
		"t26": "删除",
		"t27": "签收",
		"t28": "查看",
		"hb1": "取消订单",
		"hb2": "取消信息",
		"hb3": "请输入取消信息",
		"hb3n": "请上传取消图片",
		"hb4": "取消图片",
		"hb5": "返回",
		"hb6": "确认取消",
		"hb7": "删除订单",
		"hb8": "确定删除该订单吗？",
		"hb9": "确认删除",
		"hb10": "签收订单",
		"hb11": "签收备注",
		"hb12": "请输入签收备注",
		"hb12n": "请上传签收照片",
		"hb13": "签收照片",
		"hb14": "确认签收",
		"all": "全部",
		"t29": "待处理",
		"t30": "待发货",
		"t31": "已发货",
		"t32": "已作废",
		"t33": "单号：",
		"t34": "提交时间：",
		"t35": "长",
		"t36": "宽",
		"t37": "高",
		"t38": "体积",
		"t39": "支付",
		"t40": "请输入入单号",
		"m1": "1月",
		"m2": "2月",
		"m3": "3月",
		"m4": "4月",
		"m5": "5月",
		"m6": "6月",
		"m7": "7月",
		"m8": "8月",
		"m9": "9月",
		"m10": "10月",
		"m11": "11月",
		"m12": "12月",
	},
	"omsg": {
		"t1": "当前位置",
		"t2": "我的订单",
		"t3": "订单详情",
		"t4": "始发仓",
		"t5": "收货地址",
		"t6": "入仓号",
		"t7": "基本信息",
		"t8": "唛头",
		"t9": "运输方式",
		"t10": "付款人",
		"t11": "发货人",
		"t12": "收货人",
		"t13": "双方支付",
		"t14": "报送方式",
		"t15": "我司全代",
		"t16": "自单代报",
		"t17": "收货方式",
		"t18": "自提",
		"t19": "派送",
		"t20": "仓位号",
		"t21": "暂无",
		"t22": "货位号",
		"t23": "联系电话",
		"t24": "下单时间",
		"t25": "备注",
		"car1": "汽车出口资料",
		"car2": "暂无相关信息",
		"car3": "登记证",
		"car4": "查看",
		"car5": "行驶证",
		"car6": "合同",
		"car7": "许可证",
		"car8": "其他",
		"car9": "公里数图片",
		"car10": "公里数",
		"car11": "联系方式",
		"pay1": "费用信息",
		"pay2": "支付明细",
		"pay3": "支付状态",
		"pay4": "待支付",
		"pay5": "已支付",
		"pay6": "部分支付",
		"pay7": "运费",
		"pay8": "增值服务",
		"pay9": "应付金额(运费+增值服务)",
		"pay10": "实付金额",
		"pay11": "已支付",
		"pay12": "待支付",
		"pay13": "操作",
		"pay14": "查看运费明细",
		"o1": "物流情况",
		"o2": "当前轨迹",
		"gys1": "供应商信息",
		"gys2": "姓名",
		"gys3": "联系电话",
		"g1": "产品信息",
		"g2": "序号",
		"g3": "图片",
		"g4": "快递单号",
		"g5": "品名",
		"g6": "重量(kg)",
		"g7": "体积(㎡)",
		"g8": "货值(￥)",
		"g9": "数量",
		"g10": "打包方式",
		"g11": "打包号",
		"g12": "货物类型",
		"g13": "总货值(￥)",
		"g14": "总数量",
		"ku1": "入库信息",
		"ku2": "体积",
		"ku3": "货架号",
		"ku4": "重量",
		"ku5": "入库时间",
		"ku6": "入库图片",
		"ku7": "入库视频",
		"ku8": "装柜信息",
		"ku9": "装柜号",
		"ku10": "装柜尺寸",
		"ku11": "装柜图片",
		"ku12": "装柜视频",
		"btn1": "取消",
		"btn2": "删除",
		"btn3": "编辑",
		"btn4": "签收",
		"t26": "始",
		"t27": "终",
		"t28": "订单号：",
		"t29": "收件人信息",
		"t30": "地址：",
		"t31": "物流方案：",
		"t32": "查看明细",
		"t33": "打包信息",
		"t34": "打包时间：",
		"t35": "打包图片",
		"t36": "打包视频",
		"t37": "去支付",
		"t38": "确定取消该订单？",
		"t39": "确定取消",
	},
	"ofee": {
		"t1": "当前位置",
		"t2": "我的订单",
		"t3": "订单详情",
		"t4": "运费明细",
		"t5": "计费方式",
		"t6": "首重续重",
		"t7": "阶梯价格",
		"t8": "多级续重",
		"t9": "阶梯首重续重",
		"t10": "目的地",
		"t11": "重量",
		"t12": "体积",
		"t13": "运费",
		"t14": "计费标准",
		"t15": "首重",
		"t16": "续重",
		"t17": "最大限重",
	},
	"paylist": {
		"t1": "当前位置",
		"t2": "我的订单",
		"t3": "订单详情",
		"t4": "支付明细",
		"t5": "暂无相关信息",
		"t6": "图片",
		"t7": "付款说明",
		"t8": "付款账号",
		"t9": "交易号",
		"t10": "支付时间",
		"t11": "支付金额",
		"t12": "状态",
		"t13": "待审核",
		"t14": "审核通过",
		"t15": "审核不通过",
		"t16": "提交支付信息",
	},
	"payAdd": {
		"t1": "基础信息",
		"t2": "订单号",
		"t3": "入仓号",
		"t4": "应付",
		"t5": "已付",
		"t6": "未付",
		"t7": "付款金额",
		"t8": "请输入付款金额",
		"t9": "说明",
		"t10": "请输入说明",
		"t11": "其他信息",
		"t12": "付款账号",
		"t13": "请输入付款账号",
		"t14": "交易号",
		"t15": "请输入交易号",
		"t16": "上传截图",
		"t17": "保存",
		"t18": "请上传付款图片",
	},
	"ocang": {
		"t1": "当前位置",
		"t2": "快件下单",
		"t3": "选择仓库",
		"t4": "确定",
	},
	"shopAddr": {
		"t1": "确认订单",
		"t2": "选择收件人",
		"t3": "新增收件人",
		"t4": "收件人",
		"t5": "国家",
		"t6": "城区",
		"t7": "手机号码",
		"t8": "城市",
		"t9": "详细地址",
		"t10": "请输入收件人名字",
		"t11": "请选择",
		"t12": "请输入城区",
		"t13": "请输入手机号码",
		"t14": "请输入城市",
		"t15": "请输入详细地址",
		"t16": "保存",
		"c1": "中国",
		"c2": "美国",
		"c3": "日本",
		"c4": "韩国",
		"c5": "英国",
		"c6": "德国",
		"c7": "法国",
		"c8": "澳大利亚",
		"c9": "加拿大",
		"c10": "新加坡",
	},
	"ogoods": {
		"t1": "当前位置：",
		"t2": "快件下单",
		"t3": "编辑货物",
		"t4": "添加货物",
		"t5": "运输信息",
		"t6": "品名",
		"t7": "请输入品名",
		"t8": "重量(kg)",
		"t9": "请输入重量",
		"t10": "数量",
		"t11": "请输入数量",
		"t12": "尺寸(m³)",
		"t13": "请输入",
		"t14": "长 cm",
		"t15": "宽 cm",
		"t16": "高 cm",
		"t17": "体积(m³)",
		"t18": "请输入体积",
		"t19": "PCS",
		"t20": "请输入PCS",
		"t21": "货值(rmb)",
		"t22": "请输入货值",
		"t23": "货物类型(可多选)",
		"t24": "请选择",
		"t25": "商品状况",
		"t26": "全新",
		"t27": "二手",
		"t28": "翻新",
		"t29": "快递单号",
		"t30": "请输入快递单号",
		"t31": "上传照片",
		"t32": "修改",
		"t33": "添加",
		"t34": "请填写品名",
		"t35": "请输入数量",
		"t36": "请选择货物类型",
		"t37": "是",
		"t38": "否",
	},
	"opage": {
		"t1": "出发仓",
		"t2": "选择仓库",
		"t3": "收件人",
		"t4": "选择仓位",
		"t5": "请选择",
		"t6": "选择国家",
		"t7": "联系电话",
		"t8": "请输入联系电话",
		"t9": "唛头",
		"t10": "请选择唛头",
		"t11": "选择唛头",
		"t12": "运输信息",
		"t13": "运输方式",
		"t14": "报关方式",
		"t15": "收货方式",
		"t16": "备注",
		"t17": "请输入备注",
		"t18": "付款人",
		"t19": "供应商名称",
		"t20": "请输入供应商名称",
		"t21": "供应商电话",
		"t22": "请输入供应商手机号码",
		"t23": "增值服务",
		"t24": "汽车需要的资料",
		"t25": "是否汽车",
		"t26": "登记证",
		"t27": "点击上传，PDF或者图片",
		"t28": "查看",
		"t29": "合同",
		"t30": "其他",
		"t31": "公里数图片",
		"t32": "行驶证",
		"t33": "许可证",
		"t34": "公里数",
		"t35": "请输入公里数",
		"t36": "联系方式",
		"t37": "请输入供车商联系方式",
		"t38": "货物信息",
		"t39": "添加",
		"t40": "暂无商品信息",
		"t41": "快递单号",
		"t42": "复制",
		"t43": "编辑",
		"t44": "修改",
		"t45": "下单",
		// 选项标签
		"o1": "我司全带",
		"o2": "自单代报",
		"o3": "自提",
		"o4": "派送",
		"o5": "发货人",
		"o6": "收货人",
		"o7": "双方支付",
		"o8": "是",
		"o9": "否",
		"o10": "请选择仓位",
		// 错误提示
		"e1": "请选择仓位",
		"e2": "请输入供应商电话",
		"e3": "请上传公里数图片",
		"e4": "请输入供车商联系方式",
		"e5": "选择国家",
		"e6": "请选择唛头",
		"e7": "请添加货物信息",
		"ge0": "品　　名",
		"ge1": "数　　量",
		"ge2": "体　　积",
		"ge3": "货　　值",
		"ge4": "货物类型",
		"ge5": "长",
		"ge6": "宽",
		"ge7": "高",
		"ge8": "我的购物车",
	},
	"orderPage": {
		"t1": "货物信息",
		"t2": "添加",
		"t3": "请选择货物信息",
		"t4": "快递单号：",
		"t5": "复制",
		"t6": "删除",
		"t7": "货物名称：",
		"t8": "长：",
		"t9": "宽：",
		"t10": "高：",
		"t11": "重量：",
		"t12": "体积：",
		"t13": "收件人",
		"t14": "选择地址",
		"t15": "送货上门",
		"t16": "自提",
		"t17": "请选择收件地址",
		"t18": "物流方案",
		"t19": "计费重量：",
		"t20": "首重续重",
		"t21": "阶梯价格",
		"t22": "多级续重",
		"t23": "阶梯首重续重",
		"t24": "预估费用",
		"t25": "查看详情",
		"t26": "请选择物流方案",
		"t27": "运输信息",
		"t28": "增值服务(可多选)",
		"t29": "请选择（可多选）",
		"t30": "备注",
		"t31": "请输入备注",
		"t32": "下单",
		"t33": "添加货物",
		"t34": "暂无货物数据",
		"t35": "返回",
		"t36": "确定",
		"t37": "暂无地址数据",
		"t38": "已选",
		"t39": "关闭",
		"t40": "暂无物流方案",
		"t41": "取消",
		"t42": "选择物流方案",
		"t43": "请选择地址",
		"t44": "品类加载失败",
		"t45": "仓库加载失败",
		"t46": "货物加载失败",
		"t47": "地址加载失败",
		"t48": "请至少选择一项货物",
		"t49": "请先选择一项物流方案",
	},
	"packageAdd": {
		"t1": "添加包裹",
		"t2": "修改包裹",
		"t3": "基本信息",
		"t4": "入库仓库",
		"t5": "寄往国家",
		"t6": "请选择",
		"t7": "搜索国家/地区",
		"t8": "暂无匹配国家",
		"t9": "唛头",
		"t10": "商品信息",
		"t11": "收缩",
		"t12": "展开",
		"t13": "物品名称",
		"t14": "请输入物品名称",
		"t15": "包裹价值(元)",
		"t16": "请输入包裹价值",
		"t17": "快递单号",
		"t18": "请输入快递单号",
		"t19": "物品数量",
		"t20": "请输入物品数量",
		"t21": "物品品类",
		"t22": "请选择（可多选）",
		"t23": "备注信息",
		"t24": "请输入备注信息",
		"t25": "批量预报",
		"t26": "提交预报",
		"t27": "保存",
		"t28": "唛头加载失败",
		"t29": "仓库加载失败",
		"t30": "国家加载失败",
		"t31": "品类加载失败",
		"t32": "请选择入库仓库",
		"t33": "请选择寄住国家",
		"t34": "请选择唛头",
	},
	"packageAddMore": {
		"t1": "添加包裹",
		"t2": "批量预报",
		"t3": "基本信息",
		"t4": "入库仓库",
		"t5": "寄往国家",
		"t6": "请选择",
		"t7": "搜索国家/地区",
		"t8": "暂无匹配国家",
		"t9": "唛头",
		"t10": "批量添加快递单号",
		"t11": "请依次输入快递单号，确保每行一个快递单号*",
		"t12": "请输入快递单号",
		"t13": "物品名称",
		"t14": "请输入物品名称",
		"t15": "备注",
		"t16": "请输入备注",
		"t17": "物品品类",
		"t18": "请选择（可多选）",
		"t19": "小件数量",
		"t20": "请输入小件数量",
		"t21": "添加",
		"t22": "唛头加载失败",
		"t23": "仓库加载失败",
		"t24": "国家加载失败",
		"t25": "品类加载失败",
		"t26": "请选择入库仓库",
		"t27": "请选择寄住国家",
		"t28": "请选择唛头",
		"t29": "请选择商品品类",
	},
	"packageList": {
		"t1": "待入库",
		"t2": "已入库",
		"t3": "已集包",
		"t4": "已发货",
		"t5": "已收货",
		"t6": "已弃件",
		"t7": "产品信息",
		"t8": "唛头",
		"t9": "体积",
		"t10": "重量",
		"t11": "数量",
		"t12": "状态",
		"t13": "操作",
		"t14": "单号：",
		"t15": "提交时间：",
		"t16": "仓库：",
		"t17": "包裹属性：",
		"t18": "长",
		"t19": "宽",
		"t20": "高",
		"t21": "体积",
		"t22": "编辑",
		"t23": "删除",
		"t24": "查看详情",
		"t25": "添加包裹",
		"t26": "删除包裹",
		"t27": "确定删除该包裹吗？",
	},
	"packageMsg": {
		"t1": "包裹详情",
		"t2": "入库",
		"t3": "打包",
		"t4": "发出",
		"t5": "到达",
		"t6": "未记录",
		"t7": "产品信息",
		"t8": "数量",
		"t9": "长(cm)",
		"t10": "宽(cm)",
		"t11": "高(cm)",
		"t12": "体积(㎡)",
		"t13": "重量(kg)",
		"t14": "货物类型",
		"t15": "单号：",
		"t16": "唛头：",
		"t17": "运单详情",
		"t18": "快递单号",
		"t19": "寄往地区",
		"t20": "所在仓库",
		"t21": "客户备注",
		"t22": "入库备注",
		"t23": "预报时间",
	},
	"selPackage": {
		"t1": "待入库",
		"t2": "已入库",
		"t3": "包裹认领",
		"t4": "请选择",
		"t5": "添加包裹",
		"t6": "产品信息",
		"t7": "重量",
		"t8": "数量",
		"t9": "体积",
		"t10": "创建时间",
		"t11": "入库时间",
		"t12": "操作",
		"t13": "全选 共{num}件包裹",
		"t14": "申请打包合箱",
		"t15": "该仓库暂无包裹",
		"t16": "单号：",
		"t17": "提交时间：",
		"t18": "仓库：",
		"t19": "包裹属性：",
		"t20": "长",
		"t21": "宽",
		"t22": "高",
		"t23": "体积",
		"t24": "暂无",
		"t25": "认领",
		"t26": "查看详情",
		"t27": "领取包裹",
		"t28": "完整单号",
		"t29": "请输入完整单号",
		"t30": "用户唛头",
		"t31": "物品品类",
		"t32": "请选择（可多选）",
		"t33": "确定领取",
		"t34": "删除包裹",
		"t35": "确定删除该包裹吗？",
		"t36": "唛头加载失败",
		"t37": "品类加载失败",
		"t38": "请选择物品品类",
		"t39": "请选择唛头",
	},
	"shopCar": {
		"t1": "购物车",
		"t2": "全选",
		"t3": "暂无相关数据...",
		"t4": "自营",
		"t5": "合计",
		"t6": "去结算",
	},
	"shopCat": {
		"t1": "{count}人付款",
	},
	"shopIndex": {
		"t1": "国淘精品更便宜，跨境物流更便捷",
		"t2": "下单 商家发货 提交包裹 等待签收包裹",
		"t3": "请在此处输入您想查询的商品名称或商品链接",
		"t4": "搜索",
		"t5": "我的购物车",
		"t6": "提交代购",
		"t7": "一站式边界下单",
		"t8": "商品分类",
		"t9": "众多分类都在这",
		"t10": "领券中心",
		"t11": "快来领取折扣吧",
		"t12": "新品上市",
		"t13": "好物推荐",
		"t14": "暂无商品数据",
		"t15": "京东",
		"t16": "淘宝",
	},
	"shopMsg": {
		"t1": "原链接",
		"t2": "找相似",
		"t3": "数量",
		"t4": "不含国际运费",
		"t5": "购买须知：",
		"t6": "暂无",
		"t7": "加入购物车",
		"t8": "立即购买",
		"t9": "商品推荐",
		"t10": "商品详情",
		"t11": "请选择规格",
	},
	"shopOrder": {
		"t1": "集齐再发",
		"t2": "到货即发",
		"t3": "收货人信息",
		"t4": "新增",
		"t5": "管理",
		"t6": "暂无地址信息,请前往添加...",
		"t7": "自提",
		"t8": "送货上门",
		"t9": "收起全部地址",
		"t10": "展开全部地址",
		"t11": "选择物流方案",
		"t12": "该地址暂无物流方案",
		"t13": "计费重量：",
		"t14": "预估费用",
		"t15": "查看详情",
		"t16": "订单信息",
		"t17": "寄送仓库：",
		"t18": "请选择",
		"t19": "数量：",
		"t20": "付款详情",
		"t21": "国内运费",
		"t22": "代购服务费",
		"t23": "优惠券",
		"t24": "优惠",
		"t25": "备注",
		"t26": "选填备注信息",
		"t27": "总计：",
		"t28": "微信支付",
		"t29": "支付宝支付",
		"t30": "余额支付",
		"t31": "提交订单",
		"t32": "支付订单",
		"t33": "选择优惠券",
		"t34": "暂无可用优惠券",
		"t35": "折",
		"t36": "满{count}可用",
		"t37": "无门槛",
		"t38": "有效期：",
		"t39": "有效期：领取后{count}天",
		"t40": "取消",
		"t41": "确定",
		"t42": "微信扫码支付",
		"t43": "返回",
		"t44": "我已支付",
		"t45": "请扫码支付",
		"t46": "请选择物流方案",
		"t47": "请选择地址",
	},
	"shopSuss": {
		"t1": "当前位置：",
		"t2": "确认订单",
		"t3": "下单成功",
		"t4": "返回",
		"t5": "支付成功",
		"t6": "感谢您对我们的支持,请尽快支付订单",
		"t7": "返回首页",
		"t8": "查看订单",
	},
	"myAddr": {
		"t1": "地址管理",
		"t2": "编辑",
		"t3": "删除",
		"t4": "新增收件人",
		"t5": "删除确认",
		"t6": "是否确认删除该地址？",
		"t7": "删除成功",
		"t8": "删除失败",
	},
	"myAddrMsg": {
		"t1": "编辑收件人",
		"t2": "收件人",
		"t3": "请输入收件人名字",
		"t4": "国家",
		"t5": "搜索国家/地区",
		"t6": "无匹配结果",
		"t7": "城区",
		"t8": "请输入城市",
		"t9": "是",
		"t10": "否",
		"t11": "手机号码",
		"t12": "请输入手机号码",
		"t13": "城市",
		"t14": "请输入城区",
		"t15": "详细地址",
		"t16": "请输入详细地址",
		"t17": "选择提货点",
		"t18": "是否默认",
		"t19": "保存",
		"t20": "请填写收件人",
		"t21": "请填写手机号码",
		"t22": "请选择国家",
		"t23": "请填写城市",
		"t24": "请填写详细地址",
		"t25": "修改成功",
		"t26": "修改失败",
		"t27": "新增成功",
		"t28": "新增失败",
		"t29": "选择自提点",
		"t30": "筛选",
		"t31": "全部",
	},
	"myCollect": {
		"t1": "我的收藏",
		"t2": "自营店铺",
		"t3": "取消收藏成功",
		"t4": "取消收藏失败",
	},
	"myCoupon": {
		"t1": "我的优惠券",
		"t2": "优惠券中心",
		"t3": "待使用",
		"t4": "已使用",
		"t5": "已过期",
		"t6": "运费优惠券",
		"t7": "代购优惠券",
		"t8": "暂无相关信息...",
		"t9": "立即使用",
		"t10": "立即领取",
		"t11": "有效期：{count}天",
		"t12": "领取成功",
		"t13": "领取失败",
	},
	"myOrderPay": {
		"t1": "订单支付",
		"t2": "支付方式",
		"t3": "应付金额",
		"t4": "支付剩余时间",
		"t5": "超过时间订单将自动取消",
		"t6": "线下转账",
		"t7": "线下转账需要上传相关资料详细信息",
		"t8": "我要线下转账",
		"t9": "确认支付",
		"t10": "账号：",
		"t11": "收款人：",
		"t12": "收款银行：",
		"t13": "应付金额：",
		"t14": "转帐帐号",
		"t15": "请填写转帐帐号",
		"t16": "转帐说明",
		"t17": "请填写转帐说明",
		"t18": "支付凭证",
		"t19": "提交",
	},
	"myShopPay": {
		"t1": "我的订单",
		"t2": "订单支付",
		"t3": "支付方式",
		"t4": "应付金额",
		"t5": "微信支付",
		"t6": "支付宝支付",
		"t7": "余额支付（{money}）",
		"t8": "支付剩余时间",
		"t9": "超过时间订单将自动取消",
		"t10": "确认支付",
		"t11": "微信扫码支付",
		"t12": "返回",
		"t13": "我已支付",
		"t14": "请扫码支付",
		"t15": "线下转账",
		"t16": "账　　　号：",
		"t17": "暂无",
		"t18": "收　款　人　：",
		"t19": "收款银行：",
		"t20": "订　单　号　：",
		"t21": "应付金额：",
		"t22": "元",
		"t23": "转帐帐号",
		"t24": "请填写转帐帐号",
		"t25": "转帐说明",
		"t26": "请填写转帐说明",
		"t27": "支付凭证",
		"t28": "提交",
	},
	"myShopOrder": {
		"t1": "待付款",
		"t2": "已付款",
		"t3": "采购中",
		"t4": "已采购",
		"t5": "已完成",
		"t6": "已售后",
		"t7": "已取消",
		"t8": "商品详情",
		"t9": "创建时间",
		"t10": "商品金额(元)",
		"t11": "订单状态",
		"t12": "订单操作",
		"t13": "仓库：",
		"t14": "确定取消该订单吗？",
		"t15": "待付款，剩余支付时间",
		"t16": "已付款，您的商品正在打包中 请耐心等候",
		"t17": "采购中，您的商品正在采购中 请耐心等候",
		"t18": "已采购，您的商品已采购 请耐心等候",
		"t19": "已完成，您的订单已完成 期待再次为您服务",
		"t20": "已售后，您的订单交易失败 已关闭",
		"t21": "已取消，您的订单交易失败 已关闭",
		"t22": "收件地址",
		"t23": "物流信息",
		"t24": "物流公司：",
		"t25": "查看物流",
		"t26": "物流单号：",
		"t27": "订单信息",
		"t28": "电商编号：",
		"t29": "申请售后",
		"t30": "售后中...",
		"t31": "售后已关闭",
		"t32": "仓库",
		"t33": "物流方案",
		"t34": "付款详情",
		"t35": "商品总价",
		"t36": "运费优惠券",
		"t37": "订单编号",
		"t38": "复制",
		"t39": "付款时间",
		"t40": "采购时间",
		"t41": "完成时间",
		"t42": "关闭时间",
		"t43": "售后商品",
		"t44": "退款金额",
		"t45": "售后信息",
		"t46": "售后类型",
		"t47": "申请原因",
		"t48": "补充描述和凭证",
		"t49": "请您详细填写申请售后说明",
		"t50": "请选择售后类型",
		"t51": "请选择售后原因",
	},
}